import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Range } from 'immutable'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

import '@aytm/lib/rfd-ui/styles/swidget/stars.scss'

export const DEFAULT_STAR_ICON = 'icon-aytmfd-star'
export const DEFAULT_NA_ICON = 'icon-aytmfd-na'

export default class Stars extends PureDataComponent {
  static propTypes = {
    stars: PropTypes.number.isRequired,
    na: PropTypes.bool,
    selected: PropTypes.number,
    starIcon: PropTypes.string,
    naIcon: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    onEnter: PropTypes.func,
    onLeave: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.onEnter = this.onEnter.bind(this)
    this.onLeave = this.onLeave.bind(this)
    this.state = {
      over: null
    }
  }

  onChange(starN) {
    const { onChange } = this.props
    if ('function' == typeof onChange) onChange(starN)
  }

  onEnter(starN) {
    this.setState({ over: starN })
    const { onEnter } = this.props
    if ('function' == typeof onEnter) onEnter(starN)
  }

  onLeave() {
    this.setState({ over: null })
    const { onLeave } = this.props
    if ('function' == typeof onLeave) onLeave()
  }

  render() {
    const { stars, na, size, selected, starIcon = DEFAULT_STAR_ICON, naIcon = DEFAULT_NA_ICON } = this.props
    const { over } = this.state
    return (
      <div className="rfd-ui-stars" onMouseLeave={this.onLeave} data-testid="SW-Stars">
        {Range(0, stars)
          .map(i => (
            <div
              className={classNames('rfd-ui-stars-star', {
                'rfd-ui-stars-selected-star': null == over ? selected > i : over > i
              })}
              key={i}
              onClick={() => this.onChange(i + 1)}
              onMouseEnter={() => this.onEnter(i + 1)}
              style={{ height: size, width: size }}
              data-testid="SW-Star"
            >
              <i className={starIcon} style={{ fontSize: size, lineHeight: size }} />
            </div>
          ))
          .toArray()}
        {na && (
          <div
            className={classNames('rfd-ui-stars-na', {
              'rfd-ui-stars-selected-star': null == over ? 0 == selected : 0 == over
            })}
            onClick={() => this.onChange(0)}
            onMouseEnter={() => this.onEnter(0)}
            style={{ height: size, width: size }}
          >
            <i className={naIcon} style={{ fontSize: size, lineHeight: size }} />
          </div>
        )}
      </div>
    )
  }
}
